import { Injectable, EventEmitter, Injector } from '@angular/core';
import { Http, RequestOptions, RequestMethod, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/zip';
import { Router, RouterOutlet } from '@angular/router';
import { Configuration } from '../configurations/shared.config';
import { AuthenticationService } from './authentication.service';
import { UserControlServiceService } from './user-control-access.service';
import { DescriptiveResponse } from '../../analytics/dataModels/dashboard.data-models';
import { BaseSubscriber } from '../dataModels/base-subscriber';
import { AuthConfiguration } from '../configurations/auth.config';
import { DiagnosedItem } from '../dataModels/diagnosed-item';
import { InformationProvider } from '../providers/information.provider';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RoutingAuthenticationService extends DiagnosedItem {

    private _allowedModules = {};
    private _allowedPages = {};
    private areModulesReady: boolean = false;
    private arePagesReady: boolean = false;

    public get allowedModules() { return this._allowedModules; }
    public get allowedPages() { return this._allowedPages; }

    modulesChanged: BehaviorSubject<object> = new BehaviorSubject({});
    pagesChanged: BehaviorSubject<object> = new BehaviorSubject({});

    constructor(
        private _userControlServiceService: UserControlServiceService,
        private auth: AuthenticationService,
        private informationProvider: InformationProvider,
        protected __inj: Injector,
        private _router: Router
    ) {
        super(__inj);
    }

    async init() {

        if (!this.arePagesReady || !this.areModulesReady) {

            if (this.auth.validUser()) {
                await this.recheckAllowed();
            }
        }
    }

    recheckAllowed(foreced: boolean = false): Promise<any> {

        if (!foreced && this.areModulesReady && this.arePagesReady) {

            console.log('Return Existing Modules and Pages!');

            return new Promise((resolve, reject) => resolve([this._allowedModules, this._allowedPages]));
        }

        return Promise
            .all(
                [
                    this._userControlServiceService.getAuthorizedModules().toPromise(),
                    this._userControlServiceService.getAuthorizedPages().toPromise()
                ]
            )
            .then(res => {
                //debugger;
                console.log('Get Modules and Pages!');

                let moduleRes = res[0];
                if (!moduleRes.ErrorDescription) {
                    this._allowedModules = this.formatObject(moduleRes.Value);
                    this.modulesChanged.next(this._allowedModules);
                    this.areModulesReady = true;
                }

                let pagesRes = res[1];
                if (!pagesRes.ErrorDescription) {
                    this._allowedPages = this.formatObject(pagesRes.Value);
                    this.pagesChanged.next(this._allowedPages);
                    this.arePagesReady = true;
                }
                this.setPagesAndModulesInLocaStorage(this._allowedPages, this._allowedModules);
                return [this._allowedModules, this._allowedPages];
            }).catch(res => {
         // if(res.statusText=== "Unauthorized")
{
              this.auth.removeUser();
             this._router.navigate([Configuration.paths.loginUrl]);
}
            });
    }

    removeAllowed() {
        this._allowedModules = {};
        this._allowedPages = {};
        this.areModulesReady = false;
        this.arePagesReady = false;
        this.modulesChanged.next({});
        this.pagesChanged.next({});
    }

    getDefaultModule() {
        let prefix = Configuration.modulePrefixes;
        let _m = this._allowedModules;

        if (_m[prefix.adminLanding]) return prefix.adminLanding;
        if (_m[prefix.trackingAndMonitoring]) return prefix.trackingAndMonitoring;
        if (_m[prefix.resourceManagement]) return prefix.resourceManagement;
        if (_m[prefix.administration]) return prefix.administration;
        if (_m[prefix.analytics]) return prefix.analytics;
        if (_m[prefix.operations]) return prefix.operations;
        if (_m[prefix.accountManagement]) return prefix.accountManagement;
        if (_m[prefix.reportsAndLogs]) return prefix.reportsAndLogs;
        if (_m[prefix.devices]) return prefix.devices;
        if (_m[prefix.subscriberUsers]) return prefix.subscriberUsers;

        this.informationProvider.pageNotFound();
        return Configuration.paths.pageNotFoundUrl;
    }

    validateModule(data: string): Promise<boolean> {
        return this.validateItem(data, this.areModulesReady, this._allowedModules, 'module');
    }

    validatePage(data: string): Promise<boolean> {
        return this.validateItem(data, this.arePagesReady, this._allowedPages, 'page');
    }

    private validateItem(data: string, isReady: boolean, allowedItems: any, itemType: string = ''): Promise<boolean> {
        if (data === 'public') {
            return Promise.resolve(true);
        }

        if (isReady) {
            return Promise.resolve(allowedItems[data]);
        } else {
            return this.recheckAllowed().then((res) => {
                if (itemType === 'module') {
                    return res[0][data];
                }
                else {
                    return res[1][data];
                }
                //return allowedItems[data];
            });
        }
    }

    defaultPage(): Promise<string> {
        if (this.areModulesReady) {
            return Promise.resolve(this.getDefaultModule());
        } else {
            return this.recheckAllowed().then(() => this.getDefaultModule());
        }
    }

    validateUrl(url): Promise<boolean> {

        this.informationProvider.changeCurrentUrl(url);

        url = url.split('/').filter(x => x);

        // map the name of the module
        let moduleName = AuthConfiguration.modules[url[0]];

        let pageName = url[1];

        // if there is no page, authenticate only the module name
        if (!pageName) {
            return this.validateModule(moduleName);
        }
        else {
            // map the name of the page
            pageName = AuthConfiguration.pages[url[1]];

            let moduleObs = this.validateModule(moduleName);
            let pageObs = this.validatePage(pageName);

            return Promise.all([moduleObs, pageObs])
                .then(res => res[0] && res[1]);
        }

    }
    setPagesAndModulesInLocaStorage(pages: any, modules: any) {
        console.log("setPermissionInLocaStorage");
        localStorage.setItem('permission', JSON.stringify({ pages: pages ,modules:modules}));

    }
    // helper methods
    private formatObject(obj): Object {
        var key, keys = Object.keys(obj);
        var n = keys.length;
        var other = {}
        while (n--) {
            key = keys[n];
            other[key.toLowerCase()] = true;
        }
        return other;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/routing-authentication.ts